var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dolu"},[_c('patients'),(_vm.id_patient > 0)?_c('patient-card',{attrs:{"got_id_patient":"id_patient"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }